import { Outlet } from 'react-router-dom';
import { LoginFlowProvider } from './LoginFlowProvider';

export function LoginPage() {
  return (
    <LoginFlowProvider>
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'var(--surface-page)',
          padding: '24px 16px',
        }}
      >
        <div
          style={{
            background: 'var(--surface-base)',
            width: '100%',
            maxWidth: 440,
            borderRadius: 'var(--radius-xl)',
            border: '1px solid var(--border-default)',
            boxShadow: 'var(--shadow-overlay)',
            padding: '40px',
          }}
        >
          <div style={{ marginBottom: 32 }}>
            <h1
              style={{
                fontFamily: 'var(--font-display)',
                fontSize: 'var(--text-2xl)',
                fontWeight: 600,
                color: 'var(--text-primary)',
                margin: '0 0 4px',
                letterSpacing: '-0.03em',
              }}
            >
              Botica
            </h1>
            <p
              style={{
                margin: 0,
                fontSize: 'var(--text-sm)',
                color: 'var(--text-tertiary)',
              }}
            >
              Admin dashboard
            </p>
          </div>
          <Outlet />
        </div>
      </div>
    </LoginFlowProvider>
  );
}
